import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContractMissingFieldsSnapshot } from '@bcm-work-flows/contract-creator/contract-creator-preflight.util';

export interface ContractCreatorMissingDataDialogData {
    missingFields: ContractMissingFieldsSnapshot;
    isPerson: boolean;
}

@Component({
    selector: 'contract-creator-missing-data-dialog',
    templateUrl: './contract-creator-missing-data-dialog.component.html',
    styleUrls: ['./contract-creator-missing-data-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ContractCreatorMissingDataDialogComponent {

    constructor(
        private _dialogRef: MatDialogRef<ContractCreatorMissingDataDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: ContractCreatorMissingDataDialogData,
    ) {
        this._dialogRef.addPanelClass('default-dialog');
        this._dialogRef.disableClose = true;
    }

    onCancel(): void {
        this._dialogRef.close(false);
    }

    onContinue(): void {
        this._dialogRef.close(true);
    }
}
